import { isBasicPlanOffer } from "../helpers"
import { createRedirectCheckout } from "../payments"

export default ({
  paymentsFailPath,
  paymentsSuccessPath
} = {}) => ({
  paymentsFailPath,
  paymentsSuccessPath,
  paymentMethods: [],
  activeOffer: null,
  paymentError: false,

  init() {
    this.commonInit()
  },

  // Basic initialization to use in customized/extended views
  commonInit() {
    this.store = Alpine.store("data")

    // Passed to payment provider component (Primer, etc).
    this.paymentsFailPath = paymentsFailPath
    this.paymentsSuccessPath = paymentsSuccessPath

    // Use active offer that has been defined globally by any parent component
    this.activeOffer = this.store.values.activeOffer

    if (pipelineConfig.paymentMethods) {
      this.paymentMethods = pipelineConfig.paymentMethods
    }

    this.initPaymentError()
  },

  initPaymentError() {
    const searchParams = new URLSearchParams(window.location.search)
    const paymentError = searchParams.get("error")

    if (paymentError) {
      this.paymentError = paymentError
    }
  },

  getPriceDataValue(offer, dataKey) {
    return this.store.pricing.getPriceDataValue({ offer, dataKey })
  },

  // Specific custom logic for this UI value on payments block
  getOldPrice() {
    const isTrial = this.store.pricing.isOfferTrial(this.activeOffer)

    if (isTrial) {
      // Product quote:
      // Doesn't matter if exit intent last chance price is added,
      // the second charge will always be the same standard price.
      // It doesn't get discounted.
      return this.store.pricing.getPriceDataValue({
        offer: this.activeOffer,
        dataKey: 'trial_price_without_discount'
      })
    } else {
      // Show price without any discount set by product
      return this.store.pricing.getPriceNoDiscount({
        offer: this.activeOffer
      })
    }
  },

  getPrice() {
    return this.store.pricing.getPrice({
      offer: this.activeOffer,
      isChance: this.store.values.exitIntent && isBasicPlanOffer(this.activeOffer)
    })
  },

  getPricePerPeriod() {
    return this.store.pricing.getPricePerPeriod({
      offer: this.activeOffer,
      isChance: this.store.values.exitIntent && isBasicPlanOffer(this.activeOffer)
    })
  },

  getPriceDiscountOriginal() {
    return this.store.pricing.getPriceDiscount({
      offer: this.activeOffer,
      isChance: false,
    })
  },

  getPriceDiscount() {
    return this.store.pricing.getPriceDiscount({
      offer: this.activeOffer,
      isChance: this.store.values.exitIntent && isBasicPlanOffer(this.activeOffer)
    })
  },

  getPriceDiscountAmount() {
    return this.store.pricing.getPriceDiscountAmount({
      offer: this.activeOffer,
      isChance: this.store.values.exitIntent && isBasicPlanOffer(this.activeOffer)
    })
  },

  createRedirectCheckout(paymode) {
    createRedirectCheckout(paymode)
  },

  isExitIntentUiApplied() {
    return this.store.values.exitIntent && this.store.values.activeOffer.type.toLowerCase() === 'basic'
  },
})
